import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import Rating from '@material-ui/lab/Rating'

const useStyles = makeStyles({
  root: {
    minWidth: 270,
    
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
    textAlign: "left",
    marginTop: 12,
   
  },
  pos: {
    marginBottom: 12,
    marginBottom: 12,
    textAlign: "left"
   
  },
});

function SimpleCard() {
  const classes = useStyles();
  const bull = <span className={classes.bullet}>•</span>;

  return (
    <div classname="bt-butt rounded-lg w-100">
    <button className= 'text-dark mt-3 mb-2 border-dark bg-light border rounded-lg w-100'>  <span style={{fontSize:17, fontWeight:500}}className="text-Dark">Our 5 Stars  <img className="slider-img mr-1" src="https://sellmydevice.s3.ca-central-1.amazonaws.com/Misc_Sellmydevices/Google__G__logo.svg.png"/> 
    reviews </span>
    <Card className={classes.root}>
      <CardContent>
      <Avatar alt="Jason Bourne" src="/static/images/avatar/1.jpg" className={classes.large} />


        <Typography className={classes.title} color="textSecondary" gutterBottom>
        Jason Bourne
        </Typography>
       
        
        <img className="slider-img mt-1" src="https://sellmydevice.s3.ca-central-1.amazonaws.com/Misc_Sellmydevices/Google__G__logo.svg.png"/> 

        <Rating name="read-only" value={5} readOnly />  
       
        <Typography variant="body2" component="p">
        I sold my iPhone 11 Pro since it was sitting and accumulating dust in my drawer,  I  got an instant offer better than anywhere else! The customer service was very helpful in letting me know about the all steps involve in successful trade in.
          <br />
          {'"A must try service to get rid of old devices for best bucks"'}
        </Typography>
        
      </CardContent>
    </Card>
    <br></br>
    <Card className={classes.root}>
      <CardContent>
      <Avatar alt="Gabe Barret" src="/static/images/avatar/1.jpg" className={classes.large} />


        <Typography className={classes.title} color="textSecondary" gutterBottom>
        Gabe Barret
        </Typography>
       
       
        <img className="slider-img" src="https://sellmydevice.s3.ca-central-1.amazonaws.com/Misc_Sellmydevices/Google__G__logo.svg.png"/> 

        <Rating name="read-only" value={5} readOnly />
        <Typography variant="body2" component="p">
        Great customer experience. The reps at Sell-My-Device gave me a quote and notified me how to ship my device safely and securely. Easy to navigate website and timely service.
          
        </Typography>
        
      </CardContent>
    </Card>
    <br></br>
    <Card className={classes.root}>
      <CardContent>
      <Avatar alt="Simarjeet Kaur" src="/static/images/avatar/1.jpg" className={classes.large} />


        <Typography className={classes.title} color="textSecondary" gutterBottom>
        Simarjeet Kaur
        </Typography>
       
        
        <img className="slider-img" src="https://sellmydevice.s3.ca-central-1.amazonaws.com/Misc_Sellmydevices/Google__G__logo.svg.png"/> 

        <Rating name="read-only" value={5} readOnly />
        <Typography variant="body2" component="p">
        I sold my iPhone 13 Pro, I was offered better deal than what was offered at my local computer store. They came to the rescue me to get right value for my iPhone.
          <br />
          {'"A must try service to get rid of old devices for best bucks"'}
        </Typography>
        
      </CardContent>
    </Card>
    <br></br>
    <Card className={classes.root}>
      <CardContent>
      <Avatar alt="Alex Smith" src="/static/images/avatar/1.jpg" className={classes.large} />


        <Typography className={classes.title} color="textSecondary" gutterBottom>
        Alex Smith
        </Typography>
       
       
        <img className="slider-img" src="https://sellmydevice.s3.ca-central-1.amazonaws.com/Misc_Sellmydevices/Google__G__logo.svg.png"/> 

        <Rating name="read-only" value={5} readOnly />
        <Typography variant="body2" component="p">
        I sold my iPhone 14 Pro Max since i updgraded to iPhone 15 Pro Max, was offered a lot better value as compare to carrier's device upgrade program!
          
        </Typography>
        
      </CardContent>
    </Card></button>
   
    
   
    
    <hr></hr>
    <br></br>
    
    </div>
    
  );
}
export default SimpleCard;